import React from "react";
import IMessage from "../../../../interface/IMessage";
import { AppContext } from "../../../../store/genesys.context";
import ChatInput from "../../../atoms/inputs/chatInput.styled";
import { sendUserTyping } from "../../../../api/sendUserTyping";

export const CHAT_INPUT_HINT_ID = "chat-input-hint";
export const CHAT_INPUT_STATUS_ID = "chat-input-status";
export const CHAT_ATTACHMENTS_STATUS_ID = "chat-attachment-status";

const RenderChatInput = (): React.JSX.Element => {
  const {
    chatInput,
    setChatInput,
    handleSubmitMessage,
  }: {
    chatInput: IMessage;
    setChatInput: React.Dispatch<React.SetStateAction<IMessage>>;
    handleSubmitMessage: (e: { preventDefault: () => void }) => Promise<void>;
  } = React.useContext(AppContext);
  const inputRef = React.useRef<HTMLInputElement | null>(null);
  const previousSending = React.useRef<boolean>(chatInput.sending);

  React.useEffect(() => {
    if (previousSending.current && !chatInput.sending) {
      inputRef.current?.focus();
    }

    previousSending.current = chatInput.sending;
  }, [chatInput.sending]);

  // handle input change
  const handleOnChange = (e: any): void => {
    sendUserTyping();
    setChatInput(
      (prevState: IMessage): IMessage => ({
        ...prevState,
        text: e.target.value,
      }),
    );
  };

  // handle enter key press to submit the message
  const handleOnKeyDownEnter = (e: any): void => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      if (
        (chatInput.text.trim() !== "" || chatInput.content) &&
        !chatInput.sending
      ) {
        handleSubmitMessage(e);
      }
    }
  };

  return (
    <ChatInput
      fullWidth
      multiline
      maxRows={4}
      onKeyDown={handleOnKeyDownEnter}
      id="message-input"
      variant="outlined"
      placeholder={"Deine Nachricht"}
      value={chatInput.text}
      onChange={handleOnChange}
      inputRef={inputRef}
      disabled={chatInput.sending}
      slotProps={{
        htmlInput: {
          "aria-label": "Nachricht eingeben", // A11Y FIX
          "aria-describedby": `${CHAT_INPUT_HINT_ID} ${CHAT_INPUT_STATUS_ID} ${CHAT_ATTACHMENTS_STATUS_ID}`, // A11Y FIX
          "aria-controls": "chat-message-log", // A11Y FIX
          "aria-disabled": chatInput.sending, // A11Y FIX
        },
      }}
    />
  );
};

export default RenderChatInput;
